



























































































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "SummaryTable"
})
export default class SummaryTable extends Vue {
  @Prop()
  readonly value!: {};

  @Prop({ default: false })
  readonly unfold!: boolean;

  public showHco = true;
  public showHcp = true;

  mounted() {
    if (this.unfold) {
      this.showHco = true;
      this.showHcp = true;
    }
  }
}
